import controller from './packet-delete-success-dialog.controller';

export default {
  controller,
  template: require('./packet-delete-success-dialog.html')
};



// WEBPACK FOOTER //
// src/app/packet/packet-delete-success-dialog/packet-delete-success-dialog.component.ts